/**
 * Shared category constants for every synergy surface (deck SynergyPane,
 * commander SynergyTab, and the new profile-driven SynergyFingerprint).
 * Each view was re-declaring identical maps — this is the single source
 * of truth so a color / label tweak lands consistently everywhere.
 */

export const SYNERGY_CATEGORY_ORDER = ['triggers', 'abilities', 'statics', 'replacements'];

export const SYNERGY_CATEGORY_LABELS = {
    triggers: 'Triggered Abilities',
    abilities: 'Activated Abilities',
    statics: 'Static Abilities',
    replacements: 'Replacement Effects',
};

export const SYNERGY_CATEGORY_SHORT_LABELS = {
    triggers: 'Triggers',
    abilities: 'Abilities',
    statics: 'Statics',
    replacements: 'Replacements',
    enablers: 'Enablers',
    commanderBonus: 'Commander',
};

export const SYNERGY_CATEGORY_COLORS = {
    triggers: '#cc1a1a',
    abilities: '#e8c600',
    statics: '#4a9bd6',
    replacements: '#5fa85a',
    enablers: '#b87be8',
    commanderBonus: '#ff6ea8',
};

export const SYNERGY_DEFAULT_CATEGORY_COLOR = '#8b93a7';

export const synergyCategoryColor = (key) =>
    SYNERGY_CATEGORY_COLORS[key] || SYNERGY_DEFAULT_CATEGORY_COLOR;
